import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { checkLogin } from '../scripts/SessionHelper';
import { Row, Col, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CustomLoader from './CustomLoader';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

export const Product = () => {
	const { id: productId } = useParams();

	const [product, setProduct] = useState({
		id: '',
		name: '',
		description: '',
		images: [],
	});
	const [permissionAdmin] = useState(checkLogin());
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showImagesModal, setShowImagesModal] = useState(false);
	const [currentIndexImg, setCurrentIndexImg] = useState(0);
	const [loader, setLoader] = useState(true);

	useEffect(() => {
		const data = new FormData();
		data.append('id', productId);

		const requestOptions = {
			method: 'POST',
			body: data,
		};

		fetch('api/DataforDB/GetProduct', requestOptions)
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response.json();
			})
			.then(productData => {
				setProduct(productData);
				setLoader(false);
			})
			.catch(() => toast.error('Произошла ошибка при загрузке продукта'));
	}, [productId]);

	const removeProduct = useCallback(() => {
		const data = new FormData();
		data.append('productId', productId);

		const requestOptions = {
			method: 'POST',
			body: data,
		};

		fetch('api/DataforDB/RemoveProduct', requestOptions)
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response;
			})
			.then(() => {
				window.location.href = '/catalog';
			})
			.catch(() => {
				setShowDeleteModal(false);
				toast.error('Произошла ошибка при удалении продукта');
			});
	}, [productId]);

	const closeDeleteProductModal = useCallback(() => {
		setShowDeleteModal(false);
	}, []);

	const MAX_VISIBLE = 4;
	const images = product.images;
	const hasOverflow = images.length > MAX_VISIBLE;
	const hiddenCount = images.length - MAX_VISIBLE + 1;

	return (
		<React.Fragment>
			<CustomLoader visible={loader} />
			<div className={loader ? 'display-none' : ''}>
				<ToastContainer />
				{permissionAdmin && (
					<React.Fragment>
						<FormGroup>
							<a href={`/productEdit/${productId}`} className='btn btn-primary'>
								Редактировать
							</a>
							<button className='btn' onClick={() => setShowDeleteModal(true)}>
								Удалить
							</button>
						</FormGroup>
						<Modal isOpen={showDeleteModal}>
							<ModalHeader>Подтверждение операции</ModalHeader>
							<ModalBody>Вы уверены что хотите удалить этот продукт?</ModalBody>
							<ModalFooter>
								<button className='btn btn-primary' onClick={removeProduct}>
									Подтвердить
								</button>
								<button className='btn' onClick={closeDeleteProductModal}>
									Отменить
								</button>
							</ModalFooter>
						</Modal>
					</React.Fragment>
				)}
				<h1>{product.name || 'Кухня'}</h1>
				<FormGroup>
					<Row>
						<Col xs={12} md={6} className='product-image-container'>
							<FormGroup>
								{product.images.length > 0 ? (
									<PhotoProvider
										onIndexChange={(index) => {
											setCurrentIndexImg(index);
										}}
									>
										<div className="product-gallery">
											{images.map((img, index) => {
												const realIndex = images.findIndex(i => i.path === img.path);

												const isLastVisible =
													hasOverflow &&
													realIndex === MAX_VISIBLE - 1;

												const isHiddenImage = hasOverflow && index > MAX_VISIBLE - 1;

												return (
													<PhotoView key={img.path} src={img.path}>
														<div className={`image-wrapper ${isHiddenImage ? 'hidden' : ''}`}>
															<img
																src={img.path}
																alt=""
																className="product-image"
																onClick={() => setCurrentIndexImg(realIndex)}
															/>

															{isLastVisible && (
																<div className="more-overlay">
																	+{hiddenCount}
																</div>
															)}
														</div>
													</PhotoView>
												);
											})}
										</div>
									</PhotoProvider>
								) : (
									<div className="product-image product-image-not-found">
									<strong className="text">Изображение не найдено</strong>
									</div>
								)}
							</FormGroup>
						</Col>
						<Col xs={12} md={6}>
							<FormGroup>
								<h4>Описание</h4>
								<FormGroup>{product.description || 'Не указано'}</FormGroup>
							</FormGroup>
						</Col>
					</Row>
				</FormGroup>
			</div>
		</React.Fragment>
	);
};
